// Path: ./src/app/components/SelectWithAddMui/styled.ts
import styled from "styled-components";

interface PropsWrapper {
  wrapperStyle?: string;
}
export const Wrapper = styled.div<PropsWrapper>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  ${(props) => {
    return props?.wrapperStyle ? props.wrapperStyle : "";
  }}
`;
export const Text = styled.div`
  margin-left: 8px;
`;
export const AddValueLabel = styled.div``;

export const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin-bottom: 20px;
`;
export const TextInputLabel = styled.div`
  font-size: 18px;
  margin: 0px;
  margin-bottom: 5px;
  color: black;
  margin-top: 20px;
`;
